import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import ProveedoresCreate from "./ProveedoresCreate";
import axios from "axios";
import {
  ButtonGroup,
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Baja from "../../Baja";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import {Search } from "../../../DataTable";

function ListadoProveedores() {
  const { user } = useContext(AuthContext);
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [proveedores, setProveedores] = useState([]);
  const [modal, setModal] = useState(false);
  const [name, setName] = useState("");
    const [datosBancarios, setDatosBancarios] = useState("");
  const [tipo, setTipo] = useState("");
  const toggle = () => setModal(!modal);
  const [text, setText] = useState(false);
    const [search, setSearch] = useState("");

  const [idEdit, setIdEdit] = useState()
  const [t, i18n] = useTranslation("global");

  useEffect(() => {
    axios
      .get(URL_PROVEEDORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allProveedores = response.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function editProveedor(event) {
    event.preventDefault();
    const URL_PROVEEDORES_EDIT = `${process.env.REACT_APP_URL_PROVEEDORES}/${idEdit}`;
    axios
      .patch(
        URL_PROVEEDORES_EDIT,
        {
          name,
          datosBancarios,
          tipo
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios
        .post(
          URL_LOGS,
          {
            tipo:'Editar Proveedor',
            detalle: name,
            user: user.id
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        toggle();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        window.location.reload();
      })
       .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(idEdit, name, tipo, datosBancarios) {
        setName(name);
        setTipo(tipo);
        setDatosBancarios(datosBancarios);
        setIdEdit(idEdit);
        toggle();
  }

  return (
    <>
      <Header />
      <br />
      <br />
      <div className="container">
        { user.menuProveedores ? (
          <div className="row">
            {
              <div className="col-md-6 col-sm-6">
                <div className="card">
                  <div className="card-body">
                    
                    <h3 align="center">Proveedores</h3>
                     <Search
                      onSearch={(value) => {
                        setSearch(value);
                      }}
                    />
                    <Table
                      size="sm"
                      striped
                      borderless
                      className="table-responsive-xl"
                    >
                      <thead>
                        <tr>
                          <th className="tituloTabla">{t("Nombre")}</th>
                          <th className="tituloTabla">{t("Tipo")}</th>
                          <th className="tituloTabla">{t("Editar")}</th>
                        </tr>
                      </thead>
<tbody>
  {proveedores
    .filter((p) => {
      const q = (search || "").trim().toLowerCase();
      if (!q) return true;

      const name = (p?.name || "").toLowerCase();
      const tipo = (p?.tipo || "").toLowerCase();
      const datos = (p?.datosBancarios || "").toLowerCase();

      // busca por nombre, tipo o datos bancarios
      return (
        name.includes(q) ||
        tipo.includes(q) ||
        datos.includes(q)
      );
    })
    .sort((a, b) => (a.name > b.name ? 1 : -1))
    .map((a) => (
      <tr key={a._id}>
        <td>{a.name}</td>
        <td>{a.tipo}</td>
        <td>
          <Button
            color="info"
            id="Editar"
            size="sm"
            onClick={() => jalaInfo(a._id, a.name, a.tipo, a.datosBancarios)}
          >
            <i className="far fa-edit"></i>
          </Button>

          <Baja
            idStatus={a._id}
            is_active={a.is_active}
            URL_BAJA={process.env.REACT_APP_URL_PROVEEDORES}
          />
        </td>
      </tr>
    ))}
</tbody>

                    </Table>
                  </div>
                </div>
              </div>
            }
            <div className="col-md-6 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <ProveedoresCreate />
                </div>
              </div>
            </div>
          </div>
        ) : undefined}
      </div>
      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Editar Proveedor</ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">{t("Nombre")}</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={name}
            required
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
          
          <Label for="exampleEmail" className="mr-sm-2">
              Tipo
            </Label>
            <Input
              type="select"
              value={tipo}
              required
              onChange={(e) => {
                setTipo(e.target.value);
              }}
            >
              <option value="Admin">Admin</option>
              <option value="Agente">Agente</option>
              <option value="Custodia">Custodia</option>
              <option value="Forwarder">Forwarder</option>
              <option value="Naviera">Naviera</option>
              <option value="Servicio de Patio / Resguardo">Servicio de Patio / Resguardo</option>
              <option value="Transportista">Transportista</option>
            </Input>
             <Label className="mr-sm-2">{t("Datos Bancarios")}</Label>
                      <Input
                        className="col-sm-12"
                        type="textarea"
                        value={datosBancarios}
                        required
                        onChange={(e) => {
                          setDatosBancarios(e.target.value);
                        }}
                      />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editProveedor}>
            {t("Guardar")}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoProveedores;
